export enum UserTableAuthRole {
  // NOTE: These are defined in the DB, should be updated to ClientAuthRole in future migration
  Admin = 'admin',
  Viewer = 'viewer',
}

export enum ClientAuthRole {
  YogiAdmin = 'yogi_admin',
  YogiViewer = 'yogi_viewer',
  ClientAdmin = 'client_admin',
  ClientViewer = 'client_viewer',
  PublicViewer = 'public_viewer',
  /**
   * TODO: Extend in the future
   * - YogiSales
   * - YogiCS
   * - YogiSuperuser (eng, implementations)
   */
}

export const ClientAuthPolicy = {
  /**
   * "ONLY_ prefix = restrictive set
   * "ALL_" = most expansive option; defined only once; includes all AuthRoles
   */
  ONLY_YOGI_ADMINS: [ClientAuthRole.YogiAdmin],
  ONLY_YOGI_USERS: [ClientAuthRole.YogiAdmin, ClientAuthRole.YogiViewer],
  ONLY_ADMIN_USERS: [ClientAuthRole.YogiAdmin, ClientAuthRole.ClientAdmin],
  ONLY_AUTHENTICATED_USERS: [
    ClientAuthRole.YogiAdmin,
    ClientAuthRole.YogiViewer,
    ClientAuthRole.ClientAdmin,
    ClientAuthRole.ClientViewer,
  ],
  ONLY_YOGI_USERS_OR_CLIENT_ADMINS: [
    ClientAuthRole.YogiAdmin,
    ClientAuthRole.YogiViewer,
    ClientAuthRole.ClientAdmin,
  ],
  ALL_USERS_INCLUDING_PUBLIC_VIEWER: [
    ClientAuthRole.YogiAdmin,
    ClientAuthRole.YogiViewer,
    ClientAuthRole.ClientAdmin,
    ClientAuthRole.ClientViewer,
    ClientAuthRole.PublicViewer,
  ],
}

export const getEffectiveRole = (
  hubRole: string | undefined,
  isYogi: boolean,
  userRole: string | undefined,
): ClientAuthRole => {
  // Union the admin/viewer level across the user-level and hub-level role:
  // admin at EITHER level wins. isYogi stays the independent yogi/client
  // discriminant. See PROD-3508.
  const isAdmin =
    userRole === UserTableAuthRole.Admin || hubRole === UserTableAuthRole.Admin
  const isViewer =
    userRole === UserTableAuthRole.Viewer ||
    hubRole === UserTableAuthRole.Viewer

  if (isAdmin)
    return isYogi ? ClientAuthRole.YogiAdmin : ClientAuthRole.ClientAdmin
  if (isViewer)
    return isYogi ? ClientAuthRole.YogiViewer : ClientAuthRole.ClientViewer
  return ClientAuthRole.PublicViewer
}

export const isRoleAllowed = (
  effective: ClientAuthRole,
  allowlist: ClientAuthRole[],
): boolean => allowlist.includes(effective)
